import { useNavigate } from 'react-router-dom';

interface BreadcrumbItem {
  path?: string;
  label: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  const navigate = useNavigate();

  const handleClick = (path?: string) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <div className="mb-2 flex items-center space-x-2">
      {items.map((item, index) => (
        <div key={index} className="flex items-center space-x-2">
          {item.path ? (
            <h3
              className="text-xl font-semibold text-blue-600 cursor-pointer hover:text-blue-800 hover:underline"
              onClick={() => handleClick(item.path)}
            >
              {item.label}
            </h3>
          ) : (
            <h3 className="text-xl font-semibold text-gray-800">{item.label}</h3>
          )}
          {index < items.length - 1 && <span className="text-xl text-gray-400">/</span>}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumbs;
